import * as React from 'react';

import {PhDrugRelatedProblemDto} from './PhRecommendationDrpBaseFormatter';
import {PhRecommendationDrpListFormatter} from './PhRecommendationDrpFormatters';
import {PhRecommendationDrpItemFormatter} from './PhRecommendationDrpItemFormatter';
import {useFormatters} from '../light';

type Props = {
  problems: PhDrugRelatedProblemDto[];
  dividerWidthOffset: number;
};
export const PhRecommendationDrpInterventionsFormatter: React.FC<Props> = ({problems, dividerWidthOffset}) => {
  const {tEnum} = useFormatters();

  return (
    <PhRecommendationDrpListFormatter
      dividerWidthOffset={dividerWidthOffset}
      problems={problems}
      getItems={(drp) => drp.plannedInterventions}
      renderItem={(intervention, index) => (
        <PhRecommendationDrpItemFormatter key={index} value={tEnum('DrpPlannedIntervention', intervention)} />
      )}
    />
  );
};
PhRecommendationDrpInterventionsFormatter.displayName = 'PharmaRecommendationDrpInterventionsFormatter';
